"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ArrowUpSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.8490878,8.85306659 C12.6557006,9.04645379 12.3422329,9.04669631 12.1485466,8.85360858 L10,6.70710678 L10,15 L9,15 L9,6.70710678 L6.84304763,8.85306659 C6.64936142,9.04615433 6.33589368,9.0459118 6.14250648,8.8525246 C5.94914942,8.65916754 5.94899047,8.34572287 6.14215132,8.1521698 L9.5,4.79289322 L12.849443,8.15271179 C13.0426038,8.34626485 13.0424449,8.65970953 12.8490878,8.85306659 Z" })));
};
ArrowUpSmall.displayName = 'ArrowUpSmall';
exports.default = ArrowUpSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowUpSmall.js.map